/*
 * @Description: 暂无权限异常界面
 * @Author:  陈东东
 * @Date: 2022-05-10 09:54:50
 * @LastEditTime: 2022-05-30 17:50:29
 * @LastEditors:
 */

export default {
  path: '/noPermissionsAnomalies',
  name: 'noPermissionsAnomalies',
  component: () => import('./index.vue'),
  meta: {
    name: '暂无相关权限'
  }
};
